var map = {
	"./coingecko-mock/api-data.json": 1568,
	"./coingecko-mock/deployments/active-deployments/api3-20240506-airnode-feed.json": 7121,
	"./coingecko-mock/deployments/staging-deployments/api3-20240510-airnode-feed.json": 8905,
	"./coingecko/api-data.json": 8821,
	"./coingecko/deployments/active-deployments/api3-20240506-airnode-feed.json": 5614,
	"./coinpaprika-mock/api-data.json": 7631,
	"./coinpaprika-mock/deployments/active-deployments/api3-20240506-airnode-feed.json": 7044,
	"./coinpaprika-mock/deployments/staging-deployments/api3-20240510-airnode-feed.json": 1894,
	"./coinpaprika/api-data.json": 4620,
	"./coinpaprika/deployments/active-deployments/api3-20240506-airnode-feed.json": 7357,
	"./dxfeed-mock/api-data.json": 8650,
	"./dxfeed-mock/deployments/active-deployments/api3-20240506-airnode-feed.json": 9543,
	"./dxfeed-mock/deployments/staging-deployments/api3-20240510-airnode-feed.json": 4671,
	"./dxfeed/api-data.json": 12,
	"./dxfeed/deployments/active-deployments/api3-20240506-airnode-feed.json": 8228,
	"./finage-mock/api-data.json": 2046,
	"./finage-mock/deployments/active-deployments/api3-20240506-airnode-feed.json": 5531,
	"./finage-mock/deployments/staging-deployments/api3-20240510-airnode-feed.json": 1979,
	"./finage/api-data.json": 9523,
	"./finage/deployments/active-deployments/api3-20240506-airnode-feed.json": 6392,
	"./finnhub-mock/api-data.json": 6016,
	"./finnhub-mock/deployments/active-deployments/api3-20240506-airnode-feed.json": 1185,
	"./finnhub-mock/deployments/staging-deployments/api3-20240510-airnode-feed.json": 7001,
	"./finnhub/api-data.json": 3893,
	"./finnhub/deployments/active-deployments/api3-20240506-airnode-feed.json": 1550,
	"./iexcloud-mock/api-data.json": 433,
	"./iexcloud-mock/deployments/active-deployments/api3-20240506-airnode-feed.json": 314,
	"./iexcloud-mock/deployments/staging-deployments/api3-20240510-airnode-feed.json": 5324,
	"./iexcloud/api-data.json": 4550,
	"./iexcloud/deployments/active-deployments/api3-20240506-airnode-feed.json": 291,
	"./kaiko-mock/api-data.json": 4777,
	"./kaiko-mock/deployments/active-deployments/api3-20240506-airnode-feed.json": 3330,
	"./kaiko-mock/deployments/staging-deployments/api3-20240510-airnode-feed.json": 3300,
	"./kaiko/api-data.json": 1486,
	"./kaiko/deployments/active-deployments/api3-20240506-airnode-feed.json": 4779,
	"./ncfx-mock/api-data.json": 1887,
	"./ncfx-mock/deployments/active-deployments/api3-20240506-airnode-feed.json": 6020,
	"./ncfx-mock/deployments/staging-deployments/api3-20240510-airnode-feed.json": 2086,
	"./ncfx/api-data.json": 6204,
	"./ncfx/deployments/active-deployments/api3-20240506-airnode-feed.json": 1437,
	"./nodary-mock/api-data.json": 9607,
	"./nodary-mock/deployments/active-deployments/api3-20240508-airnode-feed.json": 8174,
	"./nodary-mock/deployments/staging-deployments/api3-20240510-airnode-feed.json": 6894,
	"./nodary/api-data.json": 9124,
	"./nodary/deployments/active-deployments/api3-20240508-airnode-feed.json": 6151,
	"./tradermade-mock/api-data.json": 6175,
	"./tradermade-mock/deployments/active-deployments/api3-20240506-airnode-feed.json": 100,
	"./tradermade-mock/deployments/staging-deployments/api3-20240510-airnode-feed.json": 2326,
	"./tradermade/api-data.json": 9244,
	"./tradermade/deployments/active-deployments/api3-20240506-airnode-feed.json": 429,
	"./twelvedata-mock/api-data.json": 5751,
	"./twelvedata-mock/deployments/active-deployments/api3-20240506-airnode-feed.json": 4172,
	"./twelvedata-mock/deployments/staging-deployments/api3-20240510-airnode-feed.json": 3294,
	"./twelvedata/api-data.json": 6916,
	"./twelvedata/deployments/active-deployments/api3-20240506-airnode-feed.json": 4645
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2516;